<div [ngClass]="!isHidden ? 'show-modal' : 'hide-modal'">
  <div class="modal-content">
    <span (click)="closeModal()" class="close">&times;</span>

    <div [ngSwitch]="changeImage">
      <!-- INCORRECT PASSCODE -->
      <div *ngSwitchCase="1">
        <div class="error-message-container">
          <img class="error-image-incorrect-passcode" src="../../../assets/incorrect_password.svg" alt="error-image" />
          <div class="error-text-container">
            <h4 class="error-title-incorrect-passcode">Oops!</h4>
            <p class="error-message-text">{{ errorMessage }}</p>
          </div>
        </div>
      </div>

      <!-- WEAK PASSCODE -->
      <div *ngSwitchCase="2">
        <div class="error-message-container">
          <img class="error-image-weak-passcode" src="../../../assets/cyber-attack.svg" alt="error-image" />
          <div class="error-text-container">
            <h4 class="error-title-weak-passcode">Watch Out!</h4>
            <p class="error-message-text">{{ errorMessage }}</p>
          </div>
        </div>
      </div>

      <!-- OTP ON THE WAY -->
      <div *ngSwitchCase="3">
        <div class="error-message-container">
          <img class="error-image-weak-passcode" src="../../../assets/paper-plane.png" alt="error-image" />
          <div class="error-text-container">
            <h4 class="error-title-weak-passcode">Heads up!</h4>
            <p class="error-message-text">{{ errorMessage }}</p>
          </div>
        </div>
      </div>

      <div *ngSwitchDefault>output2</div>
    </div>
  </div>
</div>
